import React, { useEffect, useState } from "react";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import axios from "axios";
import { CSVLink } from "react-csv";
import { baseurl } from "../../baseurl";
import {
  FaFileInvoiceDollar,
  FaRupeeSign,
  FaPercent,
  FaUndoAlt,
  FaChartLine,
  FaWallet,
} from "react-icons/fa";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function InvoiceReport() {
  const [invoices, setInvoices] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState(""); // 🟩 new state for month filter
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseurl}invoice/report`);
      if (res.data.success) {
        setInvoices(res.data.data.invoices || []);
        setAnalytics(res.data.data.analytics || {});
      }
    } catch (err) {
      console.error("Error fetching report:", err);
      Swal.fire("Error", "Failed to load report data.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  // 🟩 Filter logic (search + month)
  const filtered = invoices.filter((i) => {
    const matchesSearch =
     String(i.id).includes(search) || // ✅ Search by ID
      i.full_name?.toLowerCase().includes(search.toLowerCase()) ||
      i.phone?.includes(search) ||
      i.payment_mode?.toLowerCase().includes(search.toLowerCase());

    const invoiceMonth = i.date ? new Date(i.date).getMonth() + 1 : null;
    const invoiceYear = i.date ? new Date(i.date).getFullYear() : null;

    if (month) {
      const [filterYear, filterMonth] = month.split("-");
      const matchesMonth =
        invoiceYear === Number(filterYear) &&
        invoiceMonth === Number(filterMonth);
      return matchesSearch && matchesMonth;
    }

    return matchesSearch;
  });

  const handleView = (id) => navigate(`/invoice/${id}`);
  const handleReturn = (id) => navigate(`/invoice/${id}/return`);

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete Invoice?",
      text: "This will permanently remove the invoice record.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.delete(`${baseurl}invoices/${id}`);
        Swal.fire("Deleted!", "Invoice removed successfully.", "success");
        fetchReport();
      } catch (err) {
        Swal.fire("Error", "Failed to delete invoice.", "error");
      }
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper bg-light">
        <div className="container py-0">

          {/* ===== Report Summary ===== */}
           {/* ===== Report Summary ===== */}
          {/* <div className="card shadow-sm border-0 mb-4">
            <div className="card-body">
              <h4 className="fw-bold text-dark mb-3">
                🧾 Invoice Report Summary
              </h4>

              {analytics ? (
                <div className="row g-3">
                  {[
                    {
                      label: "Total Invoices",
                      value: analytics.total_invoices,
                      color: "card-gradient-blue",
                      icon: <FaFileInvoiceDollar />,
                    },
                    {
                      label: "Total Amount",
                      value: `₹${Math.ceil(analytics.total_amount).toFixed(2)}`,
                      color: "card-gradient-green",
                      icon: <FaRupeeSign />,
                    },
                    {
                      label: "Discount",
                      value: `₹${analytics.total_discount}`,
                      color: "card-gradient-red",
                      icon: <FaPercent />,
                    },
                    {
                      label: "Refunds",
                      value: `₹${Math.ceil(analytics.total_refund).toFixed(2)}`,
                      color: "card-gradient-orange",
                      icon: <FaUndoAlt />,
                    },
                    {
                      label: "Net After Refund",
                      value: `₹${Math.ceil(analytics.net_after_refund).toFixed(2)}`,
                      color: "card-gradient-purple",
                      icon: <FaWallet />,
                    },
                    {
                      label: "Avg Invoice",
                      value: `₹${analytics.average_invoice_value}`,
                      color: "card-gradient-gray",
                      icon: <FaChartLine />,
                    },
                  ].map((item, i) => (
                    <div className="col-md-4 col-lg-4 col-6" key={i}>
                      <div className={`summary-card ${item.color}`}>
                        <div className="summary-icon">{item.icon}</div>
                        <div className="summary-info">
                          <h6 className="text-white">{item.label}</h6>
                          <h4 className="text-white">{item.value}</h4>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-muted">No analytics data found.</p>
              )}

              {analytics?.payment_modes && (
                <div className="mt-4">
                  <h6 className="fw-bold text-secondary mb-2">
                    💳 Payment Mode Summary
                  </h6>
                  <table className="table table-bordered table-hover text-center">
                    <thead className="table-header">
                      <tr>
                        <th>Mode</th>
                        <th>Invoice Count</th>
                        <th>Total ₹</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(analytics.payment_modes).map(([mode, data]) => (
                        <tr key={mode}>
                          <td className="text-uppercase">{mode}</td>
                          <td>{data.count}</td>
                          <td>₹{data.total}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div> */}


          {/* ===== Invoice Table ===== */}
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <h5 className="fw-bold mb-0">📋 Detailed Invoice List</h5>
                <div className="d-flex flex-wrap gap-2 align-items-center">
                  {/* 🟩 Month Filter */}
                  <input
                    type="month"
                    className="form-control"
                    style={{ width: 180 }}
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                  />

                  <input
                    type="text"
                    className="form-control"
                    style={{ width: 250 }}
                    placeholder="Search name, phone, payment mode..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />

                  <CSVLink
                    data={filtered}
                    filename={`invoice-report-${month || "all"}.csv`}
                    className="btn btn-outline-primary btn-sm"
                  >
                    Export CSV
                  </CSVLink>
                </div>
              </div>

              {loading ? (
                <p className="text-center py-3">Loading invoices...</p>
              ) : filtered.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-striped align-middle text-center">
                    <thead className="table-header">
                      <tr>
                        <th>#</th>
                        <th>Customer</th>
                        <th>Phone</th>
                        <th>Date</th>
                        <th>Payment</th>
                        <th>Total ₹</th> 
                        <th>Refund ₹</th>
                        <th>Net After Refund ₹</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filtered.map((inv, i) => {
                        const totalRefund = inv.returns?.reduce(
                          (sum, r) => sum + parseFloat(r.total_refund || 0),
                          0
                        );
                        const finalNet =
                          parseFloat(inv.net_amount || 0) - totalRefund;

                        return (
                          <tr key={inv.id}>
                            <td>{inv.id}</td>
                            <td className="fw-semibold">{inv.full_name}</td>
                            <td>{inv.phone}</td>
                            <td>{new Date(inv.date).toLocaleDateString("en-GB")}</td>
                            <td>
                              <span className="badge bg-info text-white text-uppercase">
                                {inv.payment_mode}
                              </span>
                            </td>
                            <td>₹{inv.total_amount}</td> 
                            <td className="text-danger fw-bold">
                              ₹{totalRefund.toFixed(2)}
                            </td>
                            <td className="text-success fw-bold">
                              ₹{finalNet.toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-center py-3">No invoices found.</p>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default InvoiceReport;
